<template>
  <div class="cf-page-container">
    <div class="cf-card cf-card--mobile cf-flex cf-flex--column cf-flex--gap-16">
      <h1 class="cf-title cf-title--1">
        {{ merchant.options.contact.title }}
      </h1>

      <cf-formatted-content
        v-if="merchant.options.contact.description"
        :content="merchant.options.contact.description"
      />

      <template v-if="merchant.options.contact.phoneNumber || merchant.options.contact.email">
        <cf-title-separator :omit-title="true" />

        <!-- Phone Contact -->
        <div
          v-if="merchant.options.contact.phoneNumber"
          class="cf-card contact-us-links"
        >
          <a
            class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-12"
            :href="`tel:${merchant.options.contact.phoneNumber}`"
          >
            <span class="cf-icon cf-icon--brand-primary cf-icon--smedium far fa-phone" />

            <div class="cf-flex cf-flex--column">
              <p class="cf-subtitle cf-subtitle--3">
                Phone Number
              </p>

              <p class="cf-link cf-link--heavy">
                {{ $phone(merchant.options.contact.phoneNumber) }}
              </p>
            </div>
          </a>
        </div>

        <!-- Email Contact -->
        <div
          v-if="merchant.options.contact.email"
          class="cf-card contact-us-links"
        >
          <a
            class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-12"
            :href="`mailto:${merchant.options.contact.email}`"
          >
            <span class="cf-icon cf-icon--brand-primary cf-icon--smedium far fa-envelope" />

            <div class="cf-flex cf-flex--column">
              <p class="cf-subtitle cf-subtitle--3">
                Email Address
              </p>

              <p class="cf-link cf-link--heavy">
                {{ merchant.options.contact.email }}
              </p>
            </div>
          </a>
        </div>
      </template>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfFormattedContent from '@/view/components/globals/cf-formatted-content/index.vue';
  import CfTitleSeparator from '@/view/components/shared/cf-title-separator/index.vue';


  export default {
    name: 'ContactUsPage',

    components: {
      CfFormattedContent,
      CfTitleSeparator
    },

    metaInfo() {
      return {
        title: 'Contact Us'
      };
    },

    computed: {
      ...mapGetters('merchant', ['merchant'])
    }
  };
</script>


<style lang="sass" scoped>
.contact-us-links
  width: 300px
  padding: 12px

  @media (max-width: 900px)
    width: 100%
</style>
